import React, { useState } from "react";
import { Link } from "react-scroll";
import "./nav.css";

const navItems = [
  { label: "Home",         to: "home"         },
  { label: "About",        to: "about"        },
  { label: "Experience",   to: "experience"   },
  { label: "Skills",       to: "skill"        },
  { label: "Projects",     to: "project"      },
  { label: "Achievements", to: "achievements" },
  { label: "Contact",      to: "contact"      },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav
      style={{ background: "#091c29" }}
      className="sticky top-0 px-4 sm:px-16 md:px-36 lg:px-36 py-2.5 text-white z-10 border-b border-white/5"
    >
      <div className="flex flex-wrap justify-between mx-auto items-center py-3">

        {/* Logo */}
        <span className="cursor-default self-center text-xl font-semibold whitespace-nowrap">
          portfolio{" "}
          <span className="h-3 w-3 bg-red-600 inline-block rounded-full" />
        </span>

        {/* Mobile menu toggle */}
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
          className="inline-flex items-center p-2 ml-3 text-sm rounded-lg md:hidden hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-600"
        >
          <span className="sr-only">Open main menu</span>
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
            />
          </svg>
        </button>

        {/* Nav links */}
        <div className={`${isOpen ? 'block' : 'hidden'} w-full md:block md:w-auto`} id="mobile-menu">
          <ul className="flex flex-col mt-4 md:flex-row md:items-center md:gap-8 md:mt-0">
            {navItems.map(({ label, to }) => (
              <li key={to}>
                <Link
                  activeClass="nav-active"
                  to={to}
                  spy={true}
                  smooth={true}
                  offset={-64}
                  onClick={() => setIsOpen(false)}
                  className="nav-link cursor-pointer relative py-1 text-base tracking-wide font-medium text-gray-400 hover:text-white transition-colors duration-300"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </nav>
  );
}
